module.exports = {
	"Basic 1": [
		{
			"statement": "Use one of the following question words: Who or What.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Where, When, or How.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the imperative form.",
			"image": ""
		},
		{
			"statement": "Use the connector So.",
			"image": ""
		},
		{
			"statement": "Use the connector But.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Who or What.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Where, When, or How.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the imperative form.",
			"image": ""
		},
		{
			"statement": "Use the connector So.",
			"image": ""
		},
		{
			"statement": "Use the connector But.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Who or What.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Where, When, or How.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the imperative form.",
			"image": ""
		},
		{
			"statement": "Use the connector So.",
			"image": ""
		},
		{
			"statement": "Use the connector But.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Who or What.",
			"image": ""
		},
		{
			"statement": "Use one of the following question words: Where, When, or How.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the imperative form.",
			"image": ""
		},
		{
			"statement": "Use the connector So.",
			"image": ""
		},
		{
			"statement": "Use the connector But.",
			"image": ""
		}
	],
	"Basic 2": [
		{
			"statement": "Use a sentence in the simple present in the negative form.",
			"image": ""
		},
		{
			"statement": "Use a plural noun.",
			"image": ""
		},
		{
			"statement": "Use an intensifier.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present continuous in the interrogative form.",
			"image": ""
		},
		{
			"statement": "Use the possessive case.",
			"image": ""
		},
		{
			"statement": "Use Can or Could to make a request.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the simple present in the negative form.",
			"image": ""
		},
		{
			"statement": "Use a plural noun.",
			"image": ""
		},
		{
			"statement": "Use an intensifier.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present continuous in the interrogative form.",
			"image": ""
		},
		{
			"statement": "Use the possessive case.",
			"image": ""
		},
		{
			"statement": "Use Can or Could to make a request.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the simple present in the negative form.",
			"image": ""
		},
		{
			"statement": "Use a plural noun.",
			"image": ""
		},
		{
			"statement": "Use an intensifier.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present continuous in the interrogative form.",
			"image": ""
		},
		{
			"statement": "Use the possessive case.",
			"image": ""
		},
		{
			"statement": "Use Can or Could to make a request.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the simple present in the negative form.",
			"image": ""
		},
		{
			"statement": "Use a plural noun.",
			"image": ""
		},
		{
			"statement": "Use an intensifier.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present continuous in the interrogative form.",
			"image": ""
		},
		{
			"statement": "Use the possessive case.",
			"image": ""
		},
		{
			"statement": "Use Can or Could to make a request.",
			"image": ""
		}
	],
	"Basic 3": [
		{
			"statement": "Use a regular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use an irregular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use There + To Be in the past.",
			"image": ""
		},
		{
			"statement": "Ask a question using How Much or How Many.",
			"image": ""
		},
		{
			"statement": "Ask a question using Why.",
			"image": ""
		},
		{
			"statement": "Use the structure Used To.",
			"image": ""
		},
		{
			"statement": "Use a regular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use an irregular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use There + To Be in the past.",
			"image": ""
		},
		{
			"statement": "Ask a question using How Much or How Many.",
			"image": ""
		},
		{
			"statement": "Ask a question using Why.",
			"image": ""
		},
		{
			"statement": "Use the structure Used To.",
			"image": ""
		},
		{
			"statement": "Use a regular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use an irregular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use There + To Be in the past.",
			"image": ""
		},
		{
			"statement": "Ask a question using How Much or How Many.",
			"image": ""
		},
		{
			"statement": "Ask a question using Why.",
			"image": ""
		},
		{
			"statement": "Use the structure Used To.",
			"image": ""
		},
		{
			"statement": "Use a regular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use an irregular verb in an affirmative sentence in the simple past.",
			"image": ""
		},
		{
			"statement": "Use There + To Be in the past.",
			"image": ""
		},
		{
			"statement": "Ask a question using How Much or How Many.",
			"image": ""
		},
		{
			"statement": "Ask a question using Why.",
			"image": ""
		},
		{
			"statement": "Use the structure Used To.",
			"image": ""
		}
	],
	"Intermediate 1": [
		{
			"statement": "Use one of the following fillers: Let me tell you something… / The point is… / The thing is… / Hm… / How can I put this…",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past continuous + When or While.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Mustn’t.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Should.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might.",
			"image": ""
		},
		{
			"statement": "Use the structure To Be Used To.",
			"image": ""
		},
		{
			"statement": "Use one of the following fillers: Let me tell you something… / The point is… / The thing is… / Hm… / How can I put this…",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past continuous + When or While.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Mustn’t.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Should.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might.",
			"image": ""
		},
		{
			"statement": "Use the structure To Be Used To.",
			"image": ""
		},
		{
			"statement": "Use one of the following fillers: Let me tell you something… / The point is… / The thing is… / Hm… / How can I put this…",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past continuous + When or While.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Mustn’t.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Should.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might.",
			"image": ""
		},
		{
			"statement": "Use the structure To Be Used To.",
			"image": ""
		},
		{
			"statement": "Use one of the following fillers: Let me tell you something… / The point is… / The thing is… / Hm… / How can I put this…",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past continuous + When or While.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Mustn’t.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Should.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might.",
			"image": ""
		},
		{
			"statement": "Use the structure To Be Used To.",
			"image": ""
		}
	],
	"Intermediate 2": [
		{
			"statement": "Use a comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Use a superlative form.",
			"image": ""
		},
		{
			"statement": "Use the structure Be Going To with a question word.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Thus / Hence / As a consequence.",
			"image": ""
		},
		{
			"statement": "Use a reflexive pronoun.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would.",
			"image": ""
		},
		{
			"statement": "Use a comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Use a superlative form.",
			"image": ""
		},
		{
			"statement": "Use the structure Be Going To with a question word.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Thus / Hence / As a consequence.",
			"image": ""
		},
		{
			"statement": "Use a reflexive pronoun.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would.",
			"image": ""
		},
		{
			"statement": "Use a comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Use a superlative form.",
			"image": ""
		},
		{
			"statement": "Use the structure Be Going To with a question word.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Thus / Hence / As a consequence.",
			"image": ""
		},
		{
			"statement": "Use a reflexive pronoun.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would.",
			"image": ""
		},
		{
			"statement": "Use a comparative of superiority.",
			"image": ""
		},
		{
			"statement": "Use a superlative form.",
			"image": ""
		},
		{
			"statement": "Use the structure Be Going To with a question word.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Thus / Hence / As a consequence.",
			"image": ""
		},
		{
			"statement": "Use a reflexive pronoun.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would.",
			"image": ""
		}
	],
	"Intermediate 3": [
		{
			"statement": "Use a sentence in the present perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect continuous.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Who or Whose.",
			"image": ""
		},
		{
			"statement": "Use a paired conjunction.",
			"image": ""
		},
		{
			"statement": "Ask a question with Would you mind…?",
			"image": ""
		},
		{
			"statement": "Use a verb followed by gerund.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect continuous.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Who or Whose.",
			"image": ""
		},
		{
			"statement": "Use a paired conjunction.",
			"image": ""
		},
		{
			"statement": "Ask a question with Would you mind…?",
			"image": ""
		},
		{
			"statement": "Use a verb followed by gerund.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect continuous.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Who or Whose.",
			"image": ""
		},
		{
			"statement": "Use a paired conjunction.",
			"image": ""
		},
		{
			"statement": "Ask a question with Would you mind…?",
			"image": ""
		},
		{
			"statement": "Use a verb followed by gerund.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the present perfect continuous.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Who or Whose.",
			"image": ""
		},
		{
			"statement": "Use a paired conjunction.",
			"image": ""
		},
		{
			"statement": "Ask a question with Would you mind…?",
			"image": ""
		},
		{
			"statement": "Use a verb followed by gerund.",
			"image": ""
		}
	],
	"Advanced 1": [
		{
			"statement": "Use a sentence in the past perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Must + perfect or Should + perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the passive voice.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Unless, Otherwise, or Whether.",
			"image": ""
		},
		{
			"statement": "Use a conditional.",
			"image": ""
		},
		{
			"statement": "Use a relative pronoun: When or Where.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Must + perfect or Should + perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the passive voice.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Unless, Otherwise, or Whether.",
			"image": ""
		},
		{
			"statement": "Use a conditional.",
			"image": ""
		},
		{
			"statement": "Use a relative pronoun: When or Where.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Must + perfect or Should + perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the passive voice.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Unless, Otherwise, or Whether.",
			"image": ""
		},
		{
			"statement": "Use a conditional.",
			"image": ""
		},
		{
			"statement": "Use a relative pronoun: When or Where.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the past perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence with Must + perfect or Should + perfect.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the passive voice.",
			"image": ""
		},
		{
			"statement": "Use one of the following connectors: Unless, Otherwise, or Whether.",
			"image": ""
		},
		{
			"statement": "Use a conditional.",
			"image": ""
		},
		{
			"statement": "Use a relative pronoun: When or Where.",
			"image": ""
		}
	],
	"Advanced 2": [
		{
			"statement": "Use a sentence in the future perfect.",
			"image": ""
		},
		{
			"statement": "Report a statement in the affirmative form.",
			"image": ""
		},
		{
			"statement": "Report a question.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might + perfect.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would + perfect.",
			"image": ""
		},
		{
			"statement": "Use a metaphor.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the future perfect.",
			"image": ""
		},
		{
			"statement": "Report a statement in the affirmative form.",
			"image": ""
		},
		{
			"statement": "Report a question.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might + perfect.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would + perfect.",
			"image": ""
		},
		{
			"statement": "Use a metaphor.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the future perfect.",
			"image": ""
		},
		{
			"statement": "Report a statement in the affirmative form.",
			"image": ""
		},
		{
			"statement": "Report a question.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might + perfect.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would + perfect.",
			"image": ""
		},
		{
			"statement": "Use a metaphor.",
			"image": ""
		},
		{
			"statement": "Use a sentence in the future perfect.",
			"image": ""
		},
		{
			"statement": "Report a statement in the affirmative form.",
			"image": ""
		},
		{
			"statement": "Report a question.",
			"image": ""
		},
		{
			"statement": "Use the modal verbs May or Might + perfect.",
			"image": ""
		},
		{
			"statement": "Use the modal verb Would + perfect.",
			"image": ""
		},
		{
			"statement": "Use a metaphor.",
			"image": ""
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/questions2.json
// module id = 672
// module chunks = 0